import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPut } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ResetPasswordAction = createAsyncThunk("resetPassword",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPut(`${urls?.forgotPassword}/${arg.token}`, arg.payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const ResetPasswordSlice = createSlice({
    name: "resetPassword",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ResetPasswordReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ResetPasswordAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ResetPasswordAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ResetPasswordAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { ResetPasswordReset } = ResetPasswordSlice.actions
export default ResetPasswordSlice.reducer;